import CommonConstants from '../constants/CommonConstants';
import ApiConstants from '../constants/ApiConstants';

let DeliveriesActions = {
	getListError: function(error) {
		return {
			error,
			type: CommonConstants.GET_DELIVERIES_LIST_ERROR
		};
	},

	getListSuccess: function(response) {
		return {
			response,
			type: CommonConstants.GET_DELIVERIES_LIST_SUCCESS
		};
	},

	getList: function(cb){
        let token = localStorage.getItem('accessToken');
        return dispatch => {
			fetch(`${ApiConstants.getApiPath()}api/v1/deliveries`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${token}`,
					'Accept-Language': 'fr-FR'
				}
			})
			.then(res => {
				if(res.ok) {
					res.json().then(response => {
						dispatch(this.getListSuccess(response));
						cb(response);	
					})
				}else {
					let _error={
						status: res.status,
						error: res.statusText
					};
					dispatch(this.getListError(_error));
					cb(_error);
				}
			})
			.catch(error => {
				console.log('error')
				dispatch(this.getListError(error));
				cb(error);
			})
		};
	}

};

export default DeliveriesActions;



// WEBPACK FOOTER //
// ./actions/DeliveriesActions.js